module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC7SURBVHgB7dnBDYJAFEXRq7EQO9FOxMqkFOzETpDEnZmQCQYz8O5J/mZgAW8x+fMHJElSqkPFOyPbNvuPR8IZAOHiAzixTD/VQFuuU3WsYCzUjfZ0lL91lnsA4QyAcAZAuJo+oCusPWnPwEp9gCRJO1UzFH2wbfe5h06FCWcAhKs5DPVIkqQ9qjkLdIW1YaoXbTnzuSD91vMjL0f3zAAIZwCEcx7AMlfqeoh/urCAQ1HCGQDh4gOQJEm53k8jIg/YZYVbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_mobile_sidebar_icon02_sel.png
// module id = icRq
// module chunks = 1